var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mode == "edit"
        ? _c(
            "el-select",
            {
              staticClass: "wp-10",
              attrs: { filterable: "", placeholder: _vm.prop.placeholder },
              model: {
                value: _vm.localValue.numericValue,
                callback: function($$v) {
                  _vm.$set(_vm.localValue, "numericValue", $$v)
                },
                expression: "localValue.numericValue"
              }
            },
            _vm._l(_vm.options, function(item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: parseInt(item.id) }
              })
            }),
            1
          )
        : _c("p", [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }